import { FrameHealthDimension } from 'features/Health/containers/FrameHealthChartContainer/types/frameHealthDimension';

const DIMENSION = 'dimension';
const ZERO_VALUE = 0;
export const getFilteredData = (frameHealthData: FrameHealthDimension[], activeToggles: string[]) =>
  frameHealthData.map((frameHealthDimension: FrameHealthDimension) => {
    const frameHealthDimensionCopy = { ...frameHealthDimension };

    for (const key in frameHealthDimensionCopy) {
      const frameHealthDimensionKey = key as keyof FrameHealthDimension;
      const shouldExcludeFrameDimensionKey =
        !activeToggles.includes(frameHealthDimensionKey) && frameHealthDimensionKey !== DIMENSION;

      if (shouldExcludeFrameDimensionKey) {
        frameHealthDimensionCopy[frameHealthDimensionKey] = ZERO_VALUE;
      }
    }
    return frameHealthDimensionCopy;
  });
